// this corresponds to https://notify-messenger-notify-server-staging.lavanote.com/app/ and https://smartpass.app/app/

import { Environment } from './type';

export const environment: Environment = {
	production: true,
	buildType: 'prod',
	server: null,
	schoolOnboardApiRoot: 'https://smartpass.app/api/prod-us-central',
	localizejs: {
		apiKey: 'k2CZfKQ5Wqkbk',
	},
	firebase: {
		apiKey: 'AIzaSyDKAexSUkOIj63hP9MkLi22CHpykkh_4Bs',
		authDomain: 'notifyhallpass.firebaseapp.com',
		databaseURL: 'https://notifyhallpass.firebaseio.com',
		projectId: 'notifyhallpass',
		storageBucket: 'notifyhallpass.appspot.com',
		messagingSenderId: '625620388494',
		appId: '1:625620388494:web:2205663799869a91',
	},
};
